module.exports = __webpack_public_path__ + "static/media/upload-animate.99206f42.svg";